import * as React from 'react';
import { useFileSelector } from 'common-hooks';
import { CtaButton, rem, Spinner, styled, theme } from 'design-system';

type ctaButtonProps = React.ComponentProps<typeof CtaButton>;
type Props = {
  disabled: boolean;
  onClick: () => void;
  onFileSelected: (file: File) => void;
  text: string;
} & ctaButtonProps;

export const UploadButtonNudge = ({
  disabled,
  onClick,
  onFileSelected,
  text,
  ...ctaButtonProps
}: Props) => {
  const { buttonProps, inputProps } = useFileSelector({
    fileOptions: {
      supportedExtensions: ['.doc', '.docx'],
      supportedTypes: [
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ],
    },
    onClick,
    onFileSelected,
  });

  return (
    <>
      <CtaButton
        size={'big'}
        disabled={disabled}
        {...ctaButtonProps}
        {...buttonProps()}
        style={{
          fontSize: '20px',
        }}
      >
        <ButtonContainer id="Processing-Button">
          {disabled ? (
            <>
              Processing...
              <Spinner color={theme.colors.gray2} size={32} />
            </>
          ) : (
            <>
              <ButtonContent
                dangerouslySetInnerHTML={{
                  __html: text ?? '',
                }}
              />
            </>
          )}
        </ButtonContainer>
      </CtaButton>
      <input
        {...inputProps()}
        onChange={(e) => {
          const func = inputProps().onChange;
          if (func) {
            func(e);
          }
          setTimeout(() => {
            e.target.value = '';
          }, 0);
        }}
      />
    </>
  );
};

const ButtonContainer = styled('div', {
  display: 'flex',
  gap: rem(8),
  alignItems: 'center',
  justifyContent: 'center',
});

const ButtonContent = styled('div', {
  '>span': {
    backgroundColor: theme.colors.white,
    color: theme.colors.blue9,
    padding: '2px',
    paddingLeft: '4px',
    paddingRight: '4px',
    borderRadius: '5px',
    fontSize: '16px',
    fontWeight: '500',
  },
});
